import React, { useState, useEffect } from "react";

import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Table from "react-bootstrap/Table";

import { apiDelete, apiGet, apiPost, apiPut } from "../../api/server"

const MembersList = (props) => {
  
    const [inputEmail, setInputEmail] = useState("")
    const [foundMember, setFoundMember] = useState()
    const [hasEventId, setHasEventId] = useState(false)
    const [eventId, setEventId] = useState()
    const [amount, setAmount] = useState()
    const [description, setDescription] = useState()
    const [error, setError] = useState("")
    const [allEvents, setAllEvents] = useState()
    const [events, setEvents] = useState()
    const [customEventInput, setCustomEventInput] = useState(false)

    const [recentEmails, setRecentEmails] = useState([])

    useEffect(() => {
      // findMember();
      loadFromRecentsCookie();

      const now = new Date();
      apiGet(`intranetevents/getallevents`).then(res => {
        res.json().then(data => {
            setAllEvents(data.results)
            let filteredEvents = data.results.filter(event => {
              const date = new Date(event.starttime);
              if(date <= now){
                return event
              }
            })
            filteredEvents.sort((a,b) => {
              return new Date(a.starttime) - new Date(b.starttime)
            })
            filteredEvents.reverse();
            filteredEvents = [{id:"", title:"", starttime:""}].concat(filteredEvents.slice(0, 10));
            
            setEvents(filteredEvents)
        })
        })
    }, [])
    useEffect(() => {
      console.log(events)
    }, [events])

    function findMember(){
      apiGet(`intranetmembers/getmemberfabecreditsbyemail/?email=${inputEmail.toLowerCase()}`).then(res => {
        res.json().then(data => {
          setFoundMember(data)
          console.log(data)

          if (data && !data.error) {
            updateRecents(inputEmail)
          }
        })
      })
    }

  function addCredit() {
    // Valid Input Checks
    let filledFields = amount && ((hasEventId && eventId) || (!hasEventId && description));
    let validNumbers = Number.isInteger(amount * 1) && (Number.isInteger(eventId * 1) || !hasEventId);
    let validInput = filledFields && validNumbers;

    // Set Error and return if invalid
    if (!validInput) {

      if (!filledFields) {
        setError("Please fill in all available fields.")
      } else {
        setError("Please enter valid whole numbers.")
      }
      return

    } else {
      setError("")
    }

    // Set Body
    let body = null;

    if (eventId) {
      let e = allEvents.filter((v) => v.id == eventId);
      body = {
        amount: amount * 1,
        creditReason: `Attended ${e[0].title} - ${e[0].starttime.slice(0,10)}`,
        auth0sub: foundMember.member.auth0sub,
        eventId: eventId
      }
    } else {
      body = {
        amount: amount * 1,
        creditReason: description,
        auth0sub: foundMember.member.auth0sub,
      }
    }

    // Send Request
    apiPut(`intranetmembers/addfabecredit`, body).then(res => {
      res.json().then(result => {
        setFoundMember(false)
        apiGet(`intranetmembers/getmemberfabecreditsbyemail/?email=${inputEmail.toLowerCase()}`).then(res => {
          res.json().then(data => {
            setFoundMember(data)
          })
        })

      })
    })
  }

    function deleteCredit(id){
      const body = {
       id: id
      }
      apiDelete(`intranetmembers/deletefabecredit`, body).then(res => {
        setFoundMember(false)
            apiGet(`intranetmembers/getmemberfabecreditsbyemail/?email=${inputEmail.toLowerCase()}`).then(res => {
              res.json().then(data => {
                setFoundMember(data)
              })
            })
      })
    }

    function updateRecents(newemail) {
      let newarr;
      if (!recentEmails.includes(newemail)) {
        newarr = [newemail].concat(recentEmails)
      } else {
        let index = recentEmails.indexOf(newemail)
        newarr = [newemail, ...recentEmails.slice(0,index), ...recentEmails.slice(index+1)]
      }
        setRecentEmails(newarr)
        document.cookie = `recentEmails=${JSON.stringify(newarr)}; expires=Fri, 31 Dec 9999 23:59:59 GMT; path=/`
    }

    function loadFromRecentsCookie() {
      let match = document.cookie.match(new RegExp(
        "(?:^|; )" + "recentEmails" + "=([^;]*)"
      ));

      if (match) {
        setRecentEmails(JSON.parse(decodeURIComponent(match[1])))
      }
    }

    return (
        <>
        
          <Container>
            <Row>
              <Col>
                <h1>Member Credits</h1>

                  <Form.Group controlId="exampleForm.InputEmail">
                    <Form.Label>Member Email</Form.Label>
                    <Form.Control onChange={(event) => setInputEmail(event.target.value)} value={inputEmail} list={"recentlist"}>
                    </Form.Control>
                    <span style={{fontSize:"13px"}}>Note: Double click the text box when empty to see previous emails entries.</span>
                    <datalist id="recentlist">
                      {recentEmails.map((v) => {
                        return <option value={v}></option>
                      })}
                    </datalist>
                  </Form.Group>
                  <Button onClick={findMember}>
                    Find Member
                  </Button>
                  <a href={`https://business-butler-intranet.herokuapp.com/`} className="btn btn-primary">
                    Home Page
                  </a>

              </Col>
            </Row>
            {foundMember && foundMember.member && <><Row>
              {foundMember && foundMember.member && <>
                
                <div className="section">
                  <h3>Add Credit</h3>
                  <Form.Group controlId="exampleForm.InputEmail">
                    <Form.Label>Amount (eg. 10)</Form.Label>
                    <Form.Control onChange={(event) => setAmount(event.target.value)} value={amount}>

                    </Form.Control>
                  </Form.Group>
                { !hasEventId &&
                  <Form.Group controlId="exampleForm.InputEmail">
                    <Form.Label>Reason for Credit</Form.Label>
                    <Form.Control onChange={(event) => setDescription(event.target.value)} value={description}>

                    </Form.Control>
                  </Form.Group>
                }
                  <Form.Group controlId="exampleForm.InputEmail">
                    <Form.Check onChange={(event) => setHasEventId(event.target.checked)} value={hasEventId} label="Credit for Attending Event?">

                    </Form.Check>
                  </Form.Group>

                { /* EventID Dropdown */
                hasEventId && !customEventInput && (
                  <Form.Group controlId="exampleForm.InputEmail">
                    <Form.Label>Event Id</Form.Label>
                    <Form.Control as='select' onChange={(event) => setEventId(event.target.value)} value={eventId} placeholder="Please select:">
                      {events.map((v) => (
                        <option key={v.id} value={v.id}>
                          {v.id} - {v.title}, {v.starttime.slice(0,10)}
                        </option>
                      ))}
                    </Form.Control>
                  </Form.Group>
                )}

                  { /* EventID Custom Text Box */
                  hasEventId && customEventInput && <>
                    <Form.Group controlId="exampleForm.InputEmail">
                      <Form.Label>Event Id</Form.Label>
                      <Form.Control onChange={(event) => setEventId(event.target.value)} value={eventId} placeholder="E.g. 193">

                      </Form.Control>
                    </Form.Group>
                    </>
                  }

                  { /* EventID Text Box Toggle */
                  hasEventId && <>
                    <Form.Group controlId="exampleForm.InputEmail">
                      <Form.Check onChange={(event) => setCustomEventInput(event.target.checked)} value={customEventInput} label="Custom Input">

                      </Form.Check>
                    </Form.Group>
                    </>
                  }

                  <Button onClick={addCredit}>
                  Add Credit
                  </Button>
                  {error && <div style={{color: "red"}}>{error}</div>}
                </div>
              </>}
            </Row>
            <Row>
              {foundMember && <div className="section">
                <>
                  <h3>Previous Credits</h3>
                  <Table>
                    <tr>
                      <th>Amount Given</th>
                      <th>Amount Left</th>
                      <th>Date Given</th>
                      <th>Expiry Date</th>
                      <th>Reason</th>
                      <th>Event</th>
                    </tr>
                    {foundMember && foundMember.balanceTransactions.map(item => {
                      const created = new Date(item.date)
                      const expiry = new Date(item.expiry_date)
                      return <tr>
                        <td>{item.amount}</td>
                        <td>{item.amount_left}</td>
                        <td>{created.toDateString()}</td>
                        <td>{expiry.toDateString()}</td>
                        <td>{item.credit_reason}</td>
                        <td>{item.event_id}</td>
                        <td>{!(item.expired_used) && (item.amount === item.amount_left) && <Button onClick={() => deleteCredit(item.id)}>Delete</Button>}</td>
                      </tr>
                    })}
                  </Table>
                </>
              </div>}
            </Row></>}
            {foundMember && foundMember.error && <div className="section"><p>{foundMember.error}</p></div>}

            <Row>
            <div className="section">
              <h2>Credit Rules</h2>
              <ul>
                <li>A member can only use a credit on a service once</li>
                <li>If they want to try out multiple products use credit on a membership tier </li>
                <li>Cannot use credit on Network pass (as we have to pay for this)</li>
              </ul>
              </div>
            </Row>
            
            </Container>

            
        </>
      );

}

export default MembersList;